import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ToastDescriptionProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { ToastDescription } from "reka-ui"
import { cn } from "@/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastDescription',
  props: {
    asChild: { type: Boolean },
    as: {},
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, "class")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ToastDescription), _mergeProps({
    class: _unref(cn)('text-sm opacity-90', props.class)
  }, _unref(delegatedProps)), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})